import React, { createContext, useContext, useEffect } from 'react';
import Cookies from 'js-cookie';
import config from '../config';

export const ActivityContext = createContext();

export const ActivityProvider = ({ children }) => {
    const updateActivity = async () => {
        try {
            const token = Cookies.get('authToken');
            if (!token) return;

            await fetch(`${config.backendUrl}/users/update-activity/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${token}`
                }
            });
        } catch (error) {
            console.error('Error updating activity:', error);
        }
    };

    useEffect(() => {
        // Update activity every 5 minutes
        const intervalId = setInterval(updateActivity, 5 * 60 * 1000);

        // Update on page load
        updateActivity();

        // Update on page visibility change
        const handleVisibilityChange = () => {
            if (!document.hidden) {
                updateActivity();
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            clearInterval(intervalId);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    return (
        <ActivityContext.Provider value={{}}>
            {children}
        </ActivityContext.Provider>
    );
};